exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-card[data-v-83c980de]{margin-top:20px}", ""]);

// exports
